import { useState } from 'react';
import { MoreVertical, Edit2, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';

interface ScrumUpdateActionsProps {
  onEdit: () => void;
  onDelete: () => void;
}

export function ScrumUpdateActions({ onEdit, onDelete }: ScrumUpdateActionsProps) {
  const [showMenu, setShowMenu] = useState(false);

  const handleDelete = () => {
    if (confirm('Are you sure you want to delete this update? This action cannot be undone.')) {
      onDelete();
    }
    setShowMenu(false);
  };

  return (
    <div className="relative">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setShowMenu(!showMenu)}
        className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full"
      >
        <MoreVertical className="w-4 h-4" />
      </Button>

      {showMenu && (
        <div 
          className="absolute right-0 top-full mt-1 w-32 bg-white dark:bg-gray-800 rounded-md shadow-lg border border-gray-200 dark:border-gray-700 py-1 z-10"
          onClick={() => setShowMenu(false)}
        >
          <button
            onClick={onEdit}
            className="w-full px-3 py-1.5 text-left text-sm flex items-center gap-2 hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <Edit2 className="w-4 h-4" />
            Edit
          </button>
          <button
            onClick={handleDelete}
            className="w-full px-3 py-1.5 text-left text-sm flex items-center gap-2 text-red-600 dark:text-red-400 hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <Trash2 className="w-4 h-4" />
            Delete
          </button>
        </div>
      )}
    </div>
  );
}